export enum ProjectRetrievalType {
  Chase = 0,
  Member = 1,
  Gap = 2,
}
